import React, { useMemo, useState } from "react";
import campusHero from "./course-details-assets/campus-hero.jpeg";
import classroomImage from "./course-details-assets/classroom.png";
import laboratoryImage from "./course-details-assets/laboratory.png";
import libraryImage from "./course-details-assets/library.png";
import seminarImage from "./course-details-assets/seminar-hall.png";
import studentLifeImage from "./course-details-assets/student-life.png";

const serif = "font-['Libre_Caslon_Display',Georgia,serif]";
const shell =
  "mx-auto w-[min(1320px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]";

const demoCourse = {
  name: "Master of Business Administration",
  shortName: "MBA",
  school: "School of Management",
  level: "Postgraduate",
  duration: "2 Years",
  mode: "Full Time",
  intake: "2026",
  images: {
    hero: campusHero,
    classroom: classroomImage,
    laboratory: laboratoryImage,
    library: libraryImage,
    seminar: seminarImage,
    studentLife: studentLifeImage,
  },
  overview:
    "The MBA programme builds strategic perspective, managerial confidence and practical business capability through contemporary coursework, case-led learning and industry engagement.",
  eligibility:
    "A recognised bachelor’s degree in any discipline with eligibility determined according to current University admission norms.",
  highlights: [
    [
      "Case-led learning",
      "Analyse business situations and defend decisions using evidence.",
    ],
    [
      "Industry exposure",
      "Learn through expert sessions, live briefs and professional interaction.",
    ],
    [
      "Applied projects",
      "Translate management concepts into measurable organisational solutions.",
    ],
    [
      "Career preparation",
      "Strengthen aptitude, communication, interviews and professional presence.",
    ],
  ],
  reasons: [
    "A curriculum connecting management foundations with emerging business practice.",
    "Faculty-guided learning through cases, simulations, presentations and projects.",
    "Opportunities to develop leadership, analytical judgement and enterprise thinking.",
    "Structured career assistance and exposure to contemporary professional expectations.",
  ],
  programStructure: [
    { title: "Semester 1", credits: "24", marks: "600" },
    { title: "Semester 2", credits: "24", marks: "600" },
    { title: "Semester 3", credits: "24", marks: "600" },
    { title: "Semester 4", credits: "24", marks: "600" },
    { title: "Grand Total", credits: "96", marks: "2400" },
  ],
  curriculum: [
    {
      title: "Semester 1",
      subjects: [
        [
          "Management Principles & Organisational Behaviour",
          "MBA101",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        ["Managerial Economics", "MBA102", "4", "20", "10", "70", "-", "100"],
        [
          "Accounting for Managers",
          "MBA103",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Business Communication",
          "MBA104",
          "4",
          "20",
          "10",
          "50",
          "20",
          "100",
        ],
        [
          "Quantitative Techniques",
          "MBA105",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        ["Business Environment", "MBA106", "4", "20", "10", "70", "-", "100"],
      ],
    },
    {
      title: "Semester 2",
      subjects: [
        ["Marketing Management", "MBA201", "4", "20", "10", "70", "-", "100"],
        ["Financial Management", "MBA202", "4", "20", "10", "70", "-", "100"],
        [
          "Human Resource Management",
          "MBA203",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        ["Operations Management", "MBA204", "4", "20", "10", "70", "-", "100"],
        [
          "Business Research Methods",
          "MBA205",
          "4",
          "20",
          "10",
          "50",
          "20",
          "100",
        ],
        [
          "Management Information Systems",
          "MBA206",
          "4",
          "20",
          "10",
          "50",
          "20",
          "100",
        ],
      ],
    },
    {
      title: "Semester 3",
      subjects: [
        ["Strategic Management", "MBA301", "4", "20", "10", "70", "-", "100"],
        ["Business Analytics", "MBA302", "4", "20", "10", "50", "20", "100"],
        [
          "Specialisation Elective I",
          "MBA3E1",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Specialisation Elective II",
          "MBA3E2",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Specialisation Elective III",
          "MBA3E3",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Summer Internship Project",
          "MBA306",
          "4",
          "20",
          "10",
          "-",
          "70",
          "100",
        ],
      ],
    },
    {
      title: "Semester 4",
      subjects: [
        [
          "Entrepreneurship & Innovation",
          "MBA401",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Business Ethics & Corporate Governance",
          "MBA402",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Specialisation Elective IV",
          "MBA4E1",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Specialisation Elective V",
          "MBA4E2",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Specialisation Elective VI",
          "MBA4E3",
          "4",
          "20",
          "10",
          "70",
          "-",
          "100",
        ],
        [
          "Dissertation / Capstone Project",
          "MBA406",
          "4",
          "20",
          "10",
          "-",
          "70",
          "100",
        ],
      ],
    },
  ],
  specialisations: [
    "Marketing",
    "Finance",
    "Human Resource Management",
    "Business Analytics",
    "Operations",
    "Digital Business",
  ],
  skills: [
    {
      title: "Problem Solving",
      description:
        "Analyse challenges, evaluate possibilities and develop practical solutions.",
    },
    {
      title: "Technical Proficiency",
      description:
        "Build confidence with relevant tools, technologies and professional methods.",
    },
    {
      title: "Analytical Thinking",
      description:
        "Interpret information and approach decisions with structured reasoning.",
    },
    {
      title: "Communication",
      description:
        "Express ideas clearly across academic, collaborative and professional settings.",
    },
    {
      title: "Team Collaboration",
      description:
        "Contribute effectively within multidisciplinary teams and project environments.",
    },
    {
      title: "Project Execution",
      description:
        "Plan responsibilities and transform ideas into structured project outcomes.",
    },
  ],
  outcomes: [
    [
      "Business judgement",
      "Evaluate complex organisational situations and recommend responsible action.",
    ],
    [
      "Leadership",
      "Lead diverse teams with clarity, accountability and professional confidence.",
    ],
    [
      "Analytical capability",
      "Interpret business evidence and communicate defensible conclusions.",
    ],
    [
      "Enterprise mindset",
      "Recognise opportunities and develop practical, value-creating responses.",
    ],
  ],
  careers: [
    "Management Consultant",
    "Business Analyst",
    "Marketing Manager",
    "Financial Analyst",
    "HR Manager",
    "Operations Manager",
    "Entrepreneur",
    "Product Manager",
  ],
  higherStudies: [
    "Ph.D. in Management",
    "Executive education",
    "Professional finance certifications",
    "Business analytics certifications",
  ],
  related: [
    "BBA",
    "B.Com",
    "MBA in Hospital Administration",
    "MBA in Logistics & Supply Chain",
  ],
};

const recruiters = [
  "Banking",
  "Consulting",
  "FMCG",
  "Technology",
  "Retail",
  "Manufacturing",
];
const admissionSteps = [
  [
    "01",
    "Apply online",
    "Complete the University application with accurate academic and contact details.",
  ],
  [
    "02",
    "Document review",
    "The admission team verifies eligibility and supporting documents.",
  ],
  [
    "03",
    "Counselling",
    "Discuss programme fit, specialisation interests and career direction.",
  ],
  [
    "04",
    "Confirm admission",
    "Complete the prescribed admission formalities within the communicated timeline.",
  ],
];
const faqs = [
  [
    "Who can apply for the MBA programme?",
    "Graduates from a recognised university may apply subject to current University eligibility and admission norms.",
  ],
  [
    "Can students choose a specialisation?",
    "Yes. Available specialisations and elective combinations are communicated according to the applicable curriculum and academic rules.",
  ],
  [
    "Does the programme include an internship?",
    "The demo structure includes a summer internship project designed to connect classroom learning with professional practice.",
  ],
  [
    "Is placement assistance available?",
    "Students receive structured career support including aptitude preparation, resume guidance, mock interviews and industry interaction.",
  ],
];

function Eyebrow({ children, dark = false }) {
  return (
    <div
      className={`flex items-center gap-3 text-sm font-extrabold uppercase tracking-[0.14em] ${dark ? "text-[#D5AD57]" : "text-[#8B1E3F]"}`}
    >
      <span className="h-px w-10 bg-current" />
      {children}
    </div>
  );
}

function Title({ children, dark = false, as: Tag = "h2", className = "" }) {
  return (
    <Tag
      className={`${serif} mt-5 text-[clamp(38px,4.7vw,66px)] font-normal leading-[1.06] tracking-[-0.04em] ${dark ? "text-white" : "text-[#071A2F]"} ${className}`}
    >
      {children}
    </Tag>
  );
}

function Arrow() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      className="h-5 w-5"
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 12h14m-5-5 5 5-5 5"
      />
    </svg>
  );
}

export default function PremiumCourseDetailsPage({ course = demoCourse }) {
  const [semester, setSemester] = useState(0);
  const [openFaq, setOpenFaq] = useState(0);
  const currentSemester = useMemo(
    () => course.curriculum[semester],
    [course.curriculum, semester],
  );

  return (
    <main className="overflow-hidden text-[#132337]">
      {/* 01 — Banner | #071A2F */}
      <section className="relative isolate min-h-[820px] overflow-hidden bg-[#071A2F] text-white">
        <img
          src={course.images.hero}
          alt="ISBM University campus"
          className="absolute inset-0 -z-20 h-full w-full object-cover object-center opacity-55"
        />
        <div className="absolute inset-0 -z-10 bg-[linear-gradient(90deg,#071A2F_0%,rgba(7,26,47,.96)_42%,rgba(7,26,47,.5)_72%,rgba(7,26,47,.68)_100%)]" />
        <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_78%_28%,rgba(139,30,63,0.45),transparent_28%),radial-gradient(circle_at_15%_90%,rgba(213,173,87,0.12),transparent_30%)]" />
        <div className="absolute inset-0 -z-10 opacity-[0.055] [background-image:linear-gradient(#D5AD57_1px,transparent_1px),linear-gradient(90deg,#D5AD57_1px,transparent_1px)] [background-size:64px_64px]" />
        <div
          className={`${shell} flex min-h-[820px] flex-col justify-center py-28`}
        >
          <div className="max-w-5xl">
            <Eyebrow dark>
              {course.school} · Admissions {course.intake}
            </Eyebrow>
            <h1
              className={`${serif} mt-7 max-w-5xl text-[clamp(54px,7vw,100px)] font-normal leading-[0.96] tracking-[-0.055em]`}
            >
              {course.name}
            </h1>
            <p className="mt-8 max-w-2xl text-lg leading-8 text-white/65">
              Develop the insight, confidence and professional capability to
              lead in changing organisations.
            </p>
            <div className="mt-10 flex flex-wrap gap-3">
              <a
                href="#admission-process"
                className="inline-flex min-h-14 items-center gap-7 rounded-full bg-[#D5AD57] px-7 text-sm font-bold text-[#071A2F] transition hover:-translate-y-1 hover:bg-white"
              >
                Apply now <Arrow />
              </a>
              <a
                href="#curriculum"
                className="inline-flex min-h-14 items-center rounded-full border border-white/20 px-7 text-sm font-bold text-white transition hover:border-[#D5AD57] hover:text-[#D5AD57]"
              >
                Explore curriculum
              </a>
            </div>
          </div>
          <div className="mt-16 grid max-w-4xl grid-cols-2 rounded-[6px_26px_6px_6px] border border-white/15 bg-[#071A2F]/55 backdrop-blur-xl md:grid-cols-4">
            {[
              ["Level", course.level],
              ["Duration", course.duration],
              ["Mode", course.mode],
              ["Intake", course.intake],
            ].map(([label, value]) => (
              <div
                key={label}
                className="border-b border-r border-white/15 p-5 last:border-r-0 md:border-b-0"
              >
                <span className="text-sm uppercase tracking-[0.12em] text-[#D5AD57]">
                  {label}
                </span>
                <strong className="mt-2 block text-base">{value}</strong>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 02 — Overview | White */}
      <section className="bg-white py-20 sm:py-24 lg:py-28">
        <div
          className={`${shell} grid gap-10 lg:grid-cols-[0.82fr_1.18fr] lg:items-center`}
        >
          <div className="relative min-h-[520px] overflow-hidden rounded-[8px_42px_8px_8px]">
            <img
              src={course.images.classroom}
              alt="Students learning in a modern classroom"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/90 via-transparent to-transparent" />
            <div className="absolute inset-x-7 bottom-7 text-white">
              <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                Inside the learning environment
              </span>
              <strong className={`${serif} mt-3 block text-3xl`}>
                Ideas become decisions through active learning.
              </strong>
            </div>
          </div>
          <div>
            <Eyebrow>Course overview</Eyebrow>
            <Title>{course.shortName} – Course Overview</Title>
            <p className="mt-7 max-w-3xl text-lg leading-9 text-[#65717D]">
              {course.overview}
            </p>
            <div className="mt-9 grid gap-4 sm:grid-cols-3">
              {[
                "Management foundations",
                "Applied decision-making",
                "Professional readiness",
              ].map((x, i) => (
                <div
                  key={x}
                  className="border-t-2 border-[#D5AD57] bg-[#F7F2E8] p-5"
                >
                  <span className="text-sm font-bold text-[#8B1E3F]">
                    0{i + 1}
                  </span>
                  <strong className="mt-3 block text-base text-[#071A2F]">
                    {x}
                  </strong>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 03 — Why choose | Ivory */}
      <section className="bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">
        <div className={shell}>
          <div className="grid gap-10 lg:grid-cols-[0.75fr_1.25fr]">
            <div>
              <Eyebrow>Why ISBM University</Eyebrow>
              <Title as="h3">
                Why Choose {course.shortName} at ISBM University
              </Title>
            </div>
            <div className="grid gap-px bg-[#071A2F]/10 sm:grid-cols-2">
              {course.reasons.map((reason, i) => (
                <article key={reason} className="min-h-[210px] bg-white p-7">
                  <span className="text-sm font-bold text-[#8B1E3F]">
                    0{i + 1}
                  </span>
                  <p className="mt-7 text-base leading-8 text-[#526071]">
                    {reason}
                  </p>
                </article>
              ))}
            </div>
          </div>
          <div className="relative mt-10 overflow-hidden rounded-[8px_34px_8px_8px] bg-[#8B1E3F] text-white">
            <img
              src={course.images.seminar}
              alt="Industry interaction at ISBM University"
              className="absolute inset-0 h-full w-full object-cover opacity-25"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#8B1E3F] via-[#8B1E3F]/95 to-[#071A2F]/60" />
            <div className="relative flex min-h-[260px] flex-col justify-center gap-7 p-8 sm:p-10 lg:flex-row lg:items-center lg:justify-between">
              <div className="max-w-3xl">
                <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                  Experience the programme
                </span>
                <p
                  className={`${serif} mt-4 text-3xl leading-tight sm:text-4xl`}
                >
                  See how academic depth connects with professional exposure.
                </p>
              </div>
              <a
                href="/contact-us"
                className="inline-flex min-h-14 shrink-0 items-center gap-6 rounded-full bg-[#D5AD57] px-7 text-sm font-bold text-[#071A2F]"
              >
                Book a counselling session <Arrow />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 04 — Highlights | Navy */}
      <section className="relative overflow-hidden bg-[#071A2F] py-20 text-white sm:py-24 lg:py-28">
        <img
          src={course.images.laboratory}
          alt="Applied learning environment"
          className="absolute inset-0 h-full w-full object-cover opacity-[0.11]"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#071A2F] via-[#071A2F]/95 to-[#8B1E3F]/40" />
        <div className={`${shell} relative`}>
          <Eyebrow dark>Learning experience</Eyebrow>
          <Title dark>Program Highlights</Title>
          <div className="mt-12 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
            {course.highlights.map(([title, text], i) => (
              <article
                key={title}
                className="group min-h-[280px] rounded-[6px_26px_6px_6px] border border-white/15 bg-[#071A2F]/50 p-7 backdrop-blur-sm transition hover:-translate-y-1 hover:border-[#D5AD57]"
              >
                <span className={`${serif} text-5xl text-[#D5AD57]`}>
                  0{i + 1}
                </span>
                <h3 className="mt-8 text-xl font-semibold">{title}</h3>
                <p className="mt-4 text-sm leading-7 text-white/60">{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* 05 — Eligibility | White */}
      <section className="bg-white py-20 sm:py-24 lg:py-28">
        <div
          className={`${shell} grid overflow-hidden rounded-[8px_34px_8px_8px] border border-[#071A2F]/10 lg:grid-cols-[0.8fr_1.2fr]`}
        >
          <aside className="bg-[#8B1E3F] p-8 text-white sm:p-10">
            <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
              Admission eligibility
            </span>
            <Title dark>Eligibility Criteria for {course.shortName}</Title>
          </aside>
          <div className="p-8 sm:p-10 lg:p-12">
            <p className="text-lg leading-9 text-[#526071]">
              {course.eligibility}
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-3">
              {[
                ["Qualification", "Bachelor’s degree"],
                ["Selection", "As per norms"],
                ["Documents", "Academic records"],
              ].map(([a, b], i) => (
                <div key={a} className="bg-[#F7F2E8] p-5">
                  <span className="text-sm font-bold text-[#8B1E3F]">
                    0{i + 1}
                  </span>
                  <strong className="mt-3 block text-[#071A2F]">{a}</strong>
                  <span className="mt-2 block text-sm text-[#65717D]">{b}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 06 — Structure | Light blue */}
      <section id="curriculum" className="bg-[#EEF4F8] py-20 sm:py-24 lg:py-28">
        <div className={shell}>
          <div className="grid gap-10 lg:grid-cols-[1fr_.72fr] lg:items-end">
            <div>
              <Eyebrow>Academic framework</Eyebrow>
              <Title as="h3">
                {course.shortName} Curriculum &amp; Program Structure
              </Title>
            </div>
            <div className="relative h-64 overflow-hidden rounded-[7px_28px_7px_7px]">
              <img
                src={course.images.library}
                alt="ISBM University library"
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/85 to-transparent" />
              <span className="absolute bottom-5 left-5 text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                Research-ready environment
              </span>
            </div>
          </div>
          <div className="mt-12 overflow-hidden rounded-[28px] border border-[#071A2F]/10 bg-white">
            <div className="grid grid-cols-[1fr_110px_110px] bg-[#071A2F] px-6 py-4 text-sm font-bold text-white">
              <span>Academic period</span>
              <span>Credits</span>
              <span>Marks</span>
            </div>
            {course.programStructure.map((item, i) => (
              <div
                key={item.title}
                className={`grid grid-cols-[1fr_110px_110px] items-center border-b border-[#071A2F]/10 px-6 py-5 last:border-0 ${i === course.programStructure.length - 1 ? "bg-[#8B1E3F] text-white" : ""}`}
              >
                <strong>{item.title}</strong>
                <span>{item.credits}</span>
                <span>{item.marks}</span>
              </div>
            ))}
          </div>
          <div className="mt-8 flex flex-col gap-6 rounded-[24px] bg-white p-6 shadow-[0_18px_55px_rgba(7,26,47,.08)] sm:flex-row sm:items-center sm:justify-between">
            <div>
              <strong className={`${serif} text-2xl text-[#071A2F]`}>
                Need the complete syllabus?
              </strong>
              <p className="mt-2 text-sm text-[#65717D]">
                Speak with an academic counsellor for programme-specific
                guidance.
              </p>
            </div>
            <a
              href="/contact-us"
              className="inline-flex min-h-12 shrink-0 items-center gap-5 rounded-full bg-[#8B1E3F] px-6 text-sm font-bold text-white"
            >
              Request details <Arrow />
            </a>
          </div>
        </div>
      </section>

      {/* 07 — Subjects | White */}
      <section className="bg-white py-20 sm:py-24 lg:py-28">
        <div className={shell}>
          <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <Eyebrow>Detailed curriculum</Eyebrow>
              <Title>Semester-wise Syllabus / Subjects</Title>
            </div>
            <div className="flex max-w-full gap-2 overflow-x-auto pb-2">
              {course.curriculum.map((item, i) => (
                <button
                  type="button"
                  key={item.title}
                  onClick={() => setSemester(i)}
                  className={`shrink-0 rounded-full px-5 py-3 text-sm font-bold transition ${semester === i ? "bg-[#8B1E3F] text-white" : "bg-[#F7F2E8] text-[#071A2F]"}`}
                >
                  {item.title}
                </button>
              ))}
            </div>
          </div>
          <div className="mt-10 overflow-x-auto rounded-[24px] border border-[#071A2F]/10">
            <table className="w-full min-w-[960px] border-collapse text-left">
              <thead className="bg-[#071A2F] text-sm text-white">
                <tr>
                  {[
                    "Subject",
                    "Code",
                    "Credits",
                    "CT",
                    "TA",
                    "ESE",
                    "Practical",
                    "Total",
                  ].map((x) => (
                    <th key={x} className="px-5 py-4 font-semibold">
                      {x}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {currentSemester.subjects.map((s, i) => (
                  <tr
                    key={`${s[1]}-${i}`}
                    className="border-b border-[#071A2F]/10 last:border-0 hover:bg-[#F7F2E8]"
                  >
                    <td className="px-5 py-5 font-semibold text-[#071A2F]">
                      {s[0]}
                    </td>
                    {s.slice(1).map((v, j) => (
                      <td key={j} className="px-5 py-5 text-sm text-[#65717D]">
                        {v}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* 08 — Specialisations | Light burgundy */}
      <section className="bg-[#F4E8EC] py-20 sm:py-24 lg:py-28">
        <div className={shell}>
          <Eyebrow>Choose your direction</Eyebrow>
          <Title as="h4">Specializations in {course.shortName}</Title>
          <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {course.specialisations.map((x, i) => (
              <article
                key={x}
                className="group flex min-h-[150px] items-end justify-between rounded-[24px] border border-[#8B1E3F]/10 bg-white p-6 transition hover:-translate-y-1 hover:bg-[#8B1E3F] hover:text-white"
              >
                <div>
                  <span className="text-sm font-bold text-[#D5AD57]">
                    0{i + 1}
                  </span>
                  <h3 className={`${serif} mt-4 text-2xl`}>{x}</h3>
                </div>
                <Arrow />
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* 09 — Skills | Soft blush */}
      <section className="bg-[#FDF7FC] py-20 sm:py-24 lg:py-28">
        <div className={`${shell} grid gap-10 lg:grid-cols-[0.7fr_1.3fr]`}>
          <div>
            <Eyebrow>Professional capability</Eyebrow>
            <Title>Skills You&apos;ll Develop After {course.shortName}</Title>
          </div>
          <div className="grid gap-px bg-[#071A2F]/10 sm:grid-cols-2">
            {course.skills.map((x, i) => (
              <div
                key={x}
                className="flex min-h-[130px] items-center gap-5 bg-white p-6"
              >
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-[#071A2F] text-sm font-bold text-[#D5AD57]">
                  0{i + 1}
                </span>
                <strong className="text-lg text-[#071A2F]">{x}</strong>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 10 — Outcomes | Burgundy */}
      <section className="relative overflow-hidden bg-[#8B1E3F] py-20 text-white sm:py-24 lg:py-28">
        <img
          src={course.images.studentLife}
          alt="ISBM University student community"
          className="absolute inset-0 h-full w-full object-cover opacity-[0.14]"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#8B1E3F] via-[#8B1E3F]/95 to-[#071A2F]/65" />
        <div className="absolute -right-40 -top-40 h-[500px] w-[500px] rounded-full border border-white/10" />
        <div className={`${shell} relative`}>
          <Eyebrow dark>Graduate capabilities</Eyebrow>
          <Title dark>{course.shortName} Course Outcome</Title>
          <div className="mt-12 grid gap-4 md:grid-cols-2">
            {course.outcomes.map(([title, text], i) => (
              <article
                key={title}
                className="rounded-[6px_24px_6px_6px] border border-white/15 bg-[#8B1E3F]/45 p-7 backdrop-blur-sm"
              >
                <span className="text-sm font-bold text-[#D5AD57]">
                  OUTCOME 0{i + 1}
                </span>
                <h3 className={`${serif} mt-5 text-3xl`}>{title}</h3>
                <p className="mt-4 text-sm leading-7 text-white/70">{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* 11 — Careers | White */}
      <section className="bg-white py-20 sm:py-24 lg:py-28">
        <div className={shell}>
          <Eyebrow>Professional pathways</Eyebrow>
          <Title>Career Opportunities After {course.shortName}</Title>
          <div className="mt-12 grid border-l border-t border-[#071A2F]/10 sm:grid-cols-2 lg:grid-cols-4">
            {course.careers.map((x, i) => (
              <article
                key={x}
                className="min-h-[160px] border-b border-r border-[#071A2F]/10 p-6 transition hover:bg-[#F7F2E8]"
              >
                <span className="text-sm font-bold text-[#8B1E3F]">
                  0{i + 1}
                </span>
                <h3 className={`${serif} mt-7 text-2xl text-[#071A2F]`}>{x}</h3>
              </article>
            ))}
          </div>
          <div className="relative mt-10 overflow-hidden rounded-[8px_38px_8px_8px] text-white">
            <img
              src={course.images.seminar}
              alt="Professional learning and industry interaction"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#071A2F] via-[#071A2F]/90 to-[#071A2F]/25" />
            <div className="relative flex min-h-[300px] max-w-3xl flex-col justify-center p-8 sm:p-10">
              <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                Build your career story
              </span>
              <p className={`${serif} mt-4 text-4xl leading-tight`}>
                Prepare to move from academic capability to professional
                confidence.
              </p>
              <a
                href="/placements"
                className="mt-8 inline-flex min-h-14 w-fit items-center gap-6 rounded-full bg-[#D5AD57] px-7 text-sm font-bold text-[#071A2F]"
              >
                Explore career services <Arrow />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 12 — Placement | Navy */}
      <section className="bg-[#071A2F] py-20 text-white sm:py-24 lg:py-28">
        <div
          className={`${shell} grid gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:items-center`}
        >
          <div>
            <Eyebrow dark>Career services</Eyebrow>
            <Title dark as="h3">
              Top Recruiters / Placement Assistance
            </Title>
            <p className="mt-6 text-base leading-8 text-white/60">
              Structured support helps students prepare for aptitude
              assessments, interviews, group discussions, professional
              communication and evolving recruitment expectations.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-px overflow-hidden rounded-[24px] bg-white/15 sm:grid-cols-3">
            {recruiters.map((x, i) => (
              <div key={x} className="min-h-[120px] bg-[#0C2744] p-5">
                <span className="text-sm font-bold text-[#D5AD57]">
                  0{i + 1}
                </span>
                <strong className="mt-5 block">{x}</strong>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 13 — Higher studies | Light blue */}
      <section className="bg-[#EEF4F8] py-20 sm:py-24 lg:py-28">
        <div className={shell}>
          <Eyebrow>Academic progression</Eyebrow>
          <Title>Higher Studies After {course.shortName}</Title>
          <div className="mt-12 grid gap-4 md:grid-cols-2">
            {course.higherStudies.map((x, i) => (
              <article
                key={x}
                className="flex items-center gap-6 rounded-[24px] bg-white p-6 shadow-[0_16px_50px_rgba(7,26,47,0.06)]"
              >
                <span className={`${serif} text-5xl text-[#8B1E3F]/20`}>
                  0{i + 1}
                </span>
                <h3 className="text-lg font-semibold text-[#071A2F]">{x}</h3>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* 14 — Fees | Ivory */}
      <section className="bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">
        <div
          className={`${shell} grid overflow-hidden rounded-[8px_34px_8px_8px] bg-white lg:grid-cols-[1fr_0.75fr]`}
        >
          <div className="p-8 sm:p-10 lg:p-12">
            <Eyebrow>Financial information</Eyebrow>
            <Title>{course.shortName} Fees &amp; Scholarship</Title>
            <p className="mt-6 text-base leading-8 text-[#65717D]">
              Programme fees, payment schedules and applicable scholarship
              opportunities are communicated by the admissions team according to
              the current academic session.
            </p>
          </div>
          <aside className="bg-[#071A2F] p-8 text-white sm:p-10">
            <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
              Need current fee details?
            </span>
            <p className={`${serif} mt-6 text-3xl leading-tight`}>
              Request the latest fee structure and scholarship guidance.
            </p>
            <a
              href="/contact-us"
              className="mt-9 inline-flex min-h-14 items-center gap-6 rounded-full bg-[#D5AD57] px-6 text-sm font-bold text-[#071A2F]"
            >
              Talk to admissions <Arrow />
            </a>
          </aside>
        </div>
      </section>

      {/* 15 — Admission | White */}
      <section
        id="admission-process"
        className="bg-white py-20 sm:py-24 lg:py-28"
      >
        <div className={shell}>
          <div className="grid gap-10 lg:grid-cols-[.68fr_1.32fr]">
            <div className="relative min-h-[560px] overflow-hidden rounded-[8px_38px_8px_8px]">
              <img
                src={course.images.hero}
                alt="Begin your journey at ISBM University"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F] via-[#071A2F]/25 to-transparent" />
              <div className="absolute inset-x-7 bottom-7 text-white">
                <span className="text-sm font-bold uppercase tracking-[.14em] text-[#D5AD57]">
                  Admissions {course.intake}
                </span>
                <p className={`${serif} mt-3 text-4xl leading-tight`}>
                  Your next chapter can begin here.
                </p>
                <a
                  href="/apply"
                  className="mt-6 inline-flex min-h-12 items-center gap-5 rounded-full bg-[#D5AD57] px-6 text-sm font-bold text-[#071A2F]"
                >
                  Start application <Arrow />
                </a>
              </div>
            </div>
            <div>
              <Eyebrow>Your application journey</Eyebrow>
              <Title>Admission Process for {course.shortName}</Title>
              <div className="mt-10 grid gap-4 md:grid-cols-2">
                {admissionSteps.map(([n, title, text]) => (
                  <article
                    key={n}
                    className="relative min-h-[240px] overflow-hidden border border-[#071A2F]/10 p-7"
                  >
                    <span className={`${serif} text-6xl text-[#8B1E3F]/15`}>
                      {n}
                    </span>
                    <h3 className="mt-6 text-xl font-semibold text-[#071A2F]">
                      {title}
                    </h3>
                    <p className="mt-4 text-sm leading-7 text-[#65717D]">
                      {text}
                    </p>
                    <div className="absolute bottom-0 left-0 h-1 w-full bg-gradient-to-r from-[#8B1E3F] to-[#D5AD57]" />
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 16 — FAQs | Light burgundy */}
      <section className="bg-[#F4E8EC] py-20 sm:py-24 lg:py-28">
        <div className={`${shell} grid gap-10 lg:grid-cols-[0.65fr_1.35fr]`}>
          <div>
            <Eyebrow>Frequently asked questions</Eyebrow>
            <Title>FAQs About {course.shortName}</Title>
            <p className="mt-6 text-base leading-8 text-[#65717D]">
              Clear answers about eligibility, curriculum, specialisations and
              career preparation.
            </p>
          </div>
          <div className="overflow-hidden rounded-[26px] bg-white">
            {faqs.map(([q, a], i) => {
              const open = openFaq === i;
              return (
                <article
                  key={q}
                  className="border-b border-[#071A2F]/10 last:border-0"
                >
                  <button
                    type="button"
                    className="flex w-full items-center gap-5 p-6 text-left"
                    onClick={() => setOpenFaq(open ? -1 : i)}
                    aria-expanded={open}
                  >
                    <span className="text-sm font-bold text-[#8B1E3F]">
                      0{i + 1}
                    </span>
                    <strong className="flex-1 text-base text-[#071A2F]">
                      {q}
                    </strong>
                    <span className="text-2xl text-[#8B1E3F]">
                      {open ? "−" : "+"}
                    </span>
                  </button>
                  {open && (
                    <div className="px-6 pb-6 pl-[68px]">
                      <p className="text-sm leading-7 text-[#65717D]">{a}</p>
                    </div>
                  )}
                </article>
              );
            })}
          </div>
        </div>
      </section>

      {/* 17 — Related | Navy */}
      <section className="bg-[#071A2F] py-20 text-white sm:py-24 lg:py-28">
        <div className={shell}>
          <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
            <div>
              <Eyebrow dark>Continue exploring</Eyebrow>
              <Title dark>Related Programs / Explore Other Courses</Title>
            </div>
            <a
              href="/academic-programs"
              className="inline-flex items-center gap-4 text-sm font-bold text-[#D5AD57]"
            >
              View all programmes <Arrow />
            </a>
          </div>
          <div className="mt-12 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
            {course.related.map((x, i) => (
              <a
                href="/academic-programs"
                key={x}
                className="group min-h-[210px] border border-white/15 bg-white/[0.04] p-6 transition hover:-translate-y-1 hover:border-[#D5AD57]"
              >
                <span className="text-sm font-bold text-[#D5AD57]">
                  0{i + 1}
                </span>
                <h3 className={`${serif} mt-12 text-3xl`}>{x}</h3>
                <span className="mt-6 flex items-center gap-3 text-sm text-white/60 group-hover:text-white">
                  Explore programme <Arrow />
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

export { demoCourse };
